/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'antd';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { X } from 'lucide-react';
import TechnicianTeamMemberMultiSelect from './TechnicianTeamMemberMultiSelect';
import {
  filterAvailableTeamMembersForLog,
  getTeamMemberKey,
} from '../../services/dsrTechnicianTeam';
import './DownTimeModal.css';
import './TechnicianLogSection.css';
import './AddTechnicianModal.css';

const AddTechnicianModal = ({
  visible,
  onCancel,
  onConfirm,
  teamMembers = [],
  existingEmails = [],
  loading = false,
}) => {
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    if (!visible) setSelectedKeys([]);
  }, [visible]);

  const availableMembers = useMemo(
    () => filterAvailableTeamMembersForLog(teamMembers, existingEmails),
    [teamMembers, existingEmails],
  );

  const memberByKey = useMemo(() => {
    const map = new Map();
    availableMembers.forEach((member) => {
      map.set(getTeamMemberKey(member), member);
    });
    return map;
  }, [availableMembers]);

  const handleConfirm = () => {
    const picked = selectedKeys
      .map((key) => memberByKey.get(key))
      .filter(Boolean);
    onConfirm(picked);
  };

  const modalTitle = <h3 className="modern-dsr-dt-add-modal__h-title">Add technicians</h3>;

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onCancel={onCancel}
      getContainer={() => document.body}
      closeIcon={(
        <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
          <X size={20} strokeWidth={2} />
        </span>
      )}
      footer={(
        <div className="modern-dsr-dt-add-modal__foot" role="group" aria-label="Add technician actions">
          <CrceButton label="Cancel" variant="tertiary" size="medium" onClick={onCancel} disabled={loading} />
          <CrceButton
            label={loading ? 'Adding…' : `Add selected (${selectedKeys.length})`}
            variant="primary"
            size="medium"
            onClick={handleConfirm}
            disabled={loading || selectedKeys.length === 0}
          />
        </div>
      )}
      width={520}
      centered
      destroyOnClose
      className="modern-dsr-dt-add-modal modern-dsr-tech-add-modal"
      wrapClassName="modern-dsr-dt-add-modal__wrap"
    >
      <div className="modern-dsr-tech-add-modal__body">
        <p className="modern-dsr-tech-add-modal__sub">
          Choose project team members to add to this shift. Members not yet listed in DSR will be
          updated on the Team tab when you save.
        </p>

        <div className="modern-dsr-tech-add-modal__field">
          <span className="modern-dsr-tech-add-modal__label">Team members</span>
          <TechnicianTeamMemberMultiSelect
            members={availableMembers}
            selectedKeys={selectedKeys}
            onChange={setSelectedKeys}
            disabled={loading}
            placeholder="Search by name or email…"
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddTechnicianModal;
